import { useCallback, useMemo } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import type {
  PcmpCorrectionQueueParams,
  PcmpCorrectionQueueSearch,
} from '../types/pcmpCorrection.types';
import { usePcmpQueueFilters } from './usePcmpQueueFilters';

const route = getRouteApi('/_auth/pcmp/correction/');

export function usePcmpCorrectionFilters() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const setSearch = useCallback(
    (update: (prev: PcmpCorrectionQueueSearch) => PcmpCorrectionQueueSearch) => {
      void navigate({ search: update });
    },
    [navigate],
  );

  const queue = usePcmpQueueFilters(search, setSearch);
  const { appliedFilters, page, limit } = queue;

  const queueParams = useMemo<PcmpCorrectionQueueParams>(
    () => ({ ...appliedFilters, page, limit }),
    [appliedFilters, page, limit],
  );

  return { ...queue, queueParams };
}

export type PcmpCorrectionFilterController = ReturnType<typeof usePcmpCorrectionFilters>;
